import { FC, useCallback } from 'react';

import { MissingRoot } from './Missing.Root';

export const Missing: FC<{
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
}> = ({ isOpen, setIsOpen }) => {
  const onClick = useCallback(() => setIsOpen(!isOpen), [isOpen, setIsOpen]);

  return (
    <MissingRoot onClick={onClick}>
      <span>Не приходит код подтверждения?</span>
    </MissingRoot>
  );
};
